import { useMutation, useQuery } from "@tanstack/react-query";
import { createOrUpdateNickNameWeb, getNickNameDetailWeb } from "../../../../service/nickName";

const useGetNickNameDetailWeb = (enabled: boolean = true) => {
    const query = useQuery({
        queryKey: ['getNickNameDetailWeb'],
        queryFn: getNickNameDetailWeb,
        select: (res) => res.data,
        enabled: !!enabled
    })
    return query;
}

const useCreateOrUpdateNickNameWeb = () => {
    const mutation = useMutation({ mutationFn: createOrUpdateNickNameWeb })
    return mutation
}


export { useGetNickNameDetailWeb, useCreateOrUpdateNickNameWeb }